import React, { ReactNode } from 'react';
import { Spinner } from '@td-client-frontend/common';

export enum MarketingMessageType {
  LOADING = 'loading',
  MINIMAL_LENGTH = 'minimalLength',
  NO_RESULTS_FOUND = 'noResultsFound',
  TO_MANY_RESULTS = 'isOverflowed',
  DEFAULT = ''
}

const MarketingMessage = ({ messageType }: { messageType: MarketingMessageType }) => {
  const marketingMessage: Record<string, string | ReactNode> = {
    loading: (
      <div className="flex items-center justify-center text-center">
        <Spinner />
        <p className="ml-2">loading</p>
      </div>
    ),
    minimalLength: 'Please enter at least 3 characters',
    noResultsFound: 'No results found. Please try to adjust your search criteria.',
    isOverflowed: 'Too many results. Please refine your search criteria'
  };
  return (
    <div
      data-testid="marketingSearchMessage"
      className="w-full h-14 flex items-center justify-center font-effra text-normal font-sm text-grey-25 text-center"
    >
      {marketingMessage[messageType]}
    </div>
  );
};

export default MarketingMessage;
